import React, { ComponentProps } from 'react';
import { DefaultView, DeleteAction, OptionalEditView, Views } from '../../types/BlockWithViews';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  createButtonObject,
  DISPLAY_TYPE,
} from '../../components/organisms/BlockInteractions';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Icons } from '../../components/atoms/SVG';
import { BlockType } from '../../types/api/ElementType';
import { ContentImageDefaultView } from './views/ContentImageDefaultView';
import { ContentImageEditView } from './views/ContentImageEditView';
import { useContentWrapperContext } from '../../components/blocks/ContentWrapper/ContentWrapperContext';
import { useContentWrapperDndContext } from '../../components/blocks/ContentWrapper/ContentWrapperDndProvider';
import { useLayoutGroupContext } from '../../components/blocks/LayoutGroup/LayoutGroup';

type ContentImageProps = Views<
  DefaultView<ContentImageDefaultView> & OptionalEditView<ContentImageEditView> & DeleteAction
>;
function ContentImage({ activeView = 'default', views }: ContentImageProps) {
  const { t } = useSonTranslation('ContentImage');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();

  const contentWrapperProps = useContentWrapperContext();
  const contentWrapperDndProps = useContentWrapperDndContext();
  const layoutGroupProps = useLayoutGroupContext();

  const buttons = {
    ...(views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        'ContentImage:edit',
        DISPLAY_TYPE.COLLAPSIBLE,
        <ContentImageEditView {...views.edit} />,
      )),
    ...(views.delete &&
      createButtonObject(BlockInteractionsViews.DELETE, Icons.ERASER, 'ContentImage:delete', DISPLAY_TYPE.MODAL, null)),
  };

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{ text: t('headline'), hierarchy: 2, visible: true }}
      views={views}
      activeView={activeView}
      buttons={buttons}
      contentWrapperProps={contentWrapperProps}
      contentWrapperDndProps={contentWrapperDndProps}
      isInLayoutGroup={!!layoutGroupProps}
      refreshBlock={refresh}
      refreshCount={refreshCount}
    >
      <ContentImageDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const ContentImageBlock = asFetchableBlock(ContentImage, BlockType.contentimage);
export type ContentImageBlock = ComponentProps<typeof ContentImageBlock>;
